/* esm.sh - highlight.js@11.11.1/lib/languages/clojure-repl */
function a(e){return{name:"Clojure REPL",contains:[{className:"meta.prompt",begin:/^([\w.-]+|\s*#_)?=>/,starts:{end:/$/,subLanguage:"clojure"}}]}}export{a as default};
//# sourceMappingURL=clojure-repl.mjs.map